import React, {useEffect,useState} from 'react'
import {
  Button,
  Form,
  Input,
  message,
  Select,
  Upload
} from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import { SERVER_ADDRESS } from '../../../Config/Config';

const {Option} = Select;

const formItemLayout = {
  labelCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 6,
    },
  },
  wrapperCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 14,
    },
  },
};

const EditIcon = () => {
  const[form]=Form.useForm();
    const [categories, setCategories] = useState([]);
    const [styles, setStyles] = useState([]);
    const [fileList, setfileList] = useState([]);
    const { icon_id } = useParams();
    const navigate = useNavigate();
    const location = useLocation();

    const currentPage = location.state?.currentPage || 1;
    const categoryValue = location.state?.categoryValue || null;
    const iconType = location.state?.iconType || null;
    const licenseType = location.state?.licenseType || null;

    useEffect(()=>{
      const fetchIcons = async () =>{
        try {
          const response = await axios.get(`${SERVER_ADDRESS}/api/fetch-icon/${icon_id}`)
          const iconData = response.data;
          console.log(iconData)
          if (iconData) {
            // Populate form fields
            form.setFieldsValue({
              icon_name: iconData[0].icon_name,
              category_id: iconData[0].category_id,
              style_id: iconData[0].style_id,
              icon_type_id: iconData[0].icon_type_id,
              license_id: iconData[0].license_id,
              sort_by_id: iconData[0].sort_by_id,
            });

            setfileList([
              {
                uid:`-icon-${icon_id}`,
                name:iconData[0].icon_url.split('/').pop(),
                status:'done',
                url:iconData[0].icon_url
              }
            ]);

          } else {
            message.error('Failed to fetch icon data');
          }
        } catch (error) {
            message.error({content:'Internal server error', duration:2})
        }
      }
      fetchIcons();
    },[icon_id,form])

    //Fetch category
      useEffect(() => {
        const fetchCategories = async () => {
           try {
             const response = await axios.get(`${SERVER_ADDRESS}/api/category-list`); 
             setCategories(response.data); 
           } catch (error) {
             message.error("Failed to fetch categories");
             console.error(error);
           }
         };
         fetchCategories();
       }, []);
    
    //Fetch Style
    useEffect(() => {
        const fetchstyles = async () =>{
            try {
                const response = await axios.get(`${SERVER_ADDRESS}/api/style-list`);
                setStyles(response.data);
            } catch (error) {
                message.error({content:'Cannot fetch style', duration:2})
                console.log(error)
            }
        };
        fetchstyles();
    },[]) 
    
    const handleIconSubmit = async (values) => {
      const formData = new FormData();
  
      // Append form fields to FormData
      Object.keys(values).forEach((key) => {
          formData.append(key, values[key]);
      });
  
      // Check if the fileList contains a file or if it's a URL
      if (fileList.length > 0 && fileList[0].url) {
          // If it's a URL, send the URL
          formData.append('icon_url', fileList[0].url);
      } else if (fileList.length > 0 && fileList[0].originFileObj) {
          // If it's a file, send the file
          formData.append('icon_files', fileList[0].originFileObj); // Single file
      } else {
          message.error('Please upload a file or provide a URL');
          return;
      }
  
      try {
          const response = await axios.post(`${SERVER_ADDRESS}/api/edit-icons/${icon_id}`, formData, {
              headers: {
                  'Content-Type': 'multipart/form-data',
              },
          });
          message.success('Icon updated successfully!');
          form.resetFields();
          setfileList([]);
          navigate(`/frontend/dashboard/icon/icon-list?page=${currentPage}`,{
            state: {currentPage,
              categoryValue,
              iconType,
              licenseType
            }
          }); 
      } catch (error) {
          console.error('API Error:', error);
          message.error('Failed to update icon');
      }
    };
  
      

    // File upload props
    const onChange = ({ fileList: newFileList }) => {
        setfileList(newFileList.slice(-1));
      };

  return (
    <div style={{
        marginTop:'5rem',
      }}>
        <div style={{
          fontSize:'2rem'
        }}>
          Fill Details
        </div>
      <Form
        form={form}
      style={{
        backgroundColor:'white',
        width:'60rem',
        marginTop:'1rem',
        padding:'2rem',
        justifySelf:'center',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
        borderRadius:'0.6rem'
      }}
      labelCol={{span: 3}}
      wrapperCol={{span:14,offset:2}}
      onFinish={handleIconSubmit}
  >   .class
        <Form.Item label="Icon Name" name="icon_name" rules={[{ required: true, message: 'Enter the style name' }]} ><Input placeholder="Enter Icon name"></Input></Form.Item>
        <Form.Item label="Category" name="category_id" rules={[{required:true, message:'Select the category'}]}>
            <Select placeholder="Select a category">
                {categories.map((category)=>(
                    <Option key={category.category_id} value={category.category_id}>{category.category_name}</Option>
                ))}
            </Select></Form.Item>
        <Form.Item label="Style" name="style_id" rules={[{required:true, message:'Select the style'}]} >
                <Select placeholder="Select the style" >
                    {styles.map((style)=>(
                        <Option key={style.style_id} value={style.style_id}>{style.style_name}</Option>
                    ))}
                </Select>
        </Form.Item>
        <Form.Item label="Icon Type" name="icon_type_id" rules={[{required:true, message:'Select the Icon Type'}]} >
                <Select placeholder="Select the Icon Type" >
                    <Option key={1} value={1}>Static</Option>
                    <Option key={2} value={2}>Animation</Option>
                </Select>
        </Form.Item>
        <Form.Item label="License" name="license_id" rules={[{required:true, message:'Select the License'}]} >
                <Select placeholder="Select the License" >
                    <Option key={1} value={1}>Free</Option>
                    <Option key={2} value={2}>Premium</Option>
                </Select>
        </Form.Item>
        <Form.Item label="Sort By" name="sort_by_id" rules={[{required:true, message:'Select the Sort By'}]} >
                <Select placeholder="Select the Sort By" >
                    <Option key={1} value={1}>Popular</Option>
                    <Option key={2} value={2}>Recent</Option>
                </Select>
        </Form.Item>
        <Form.Item label="Upload Icon" rules={[{ required: true, message: 'Please upload an icon file!' }]} >
            <Upload name='icons[]' accept='.svg' showUploadList={{showPreviewIcon:false,showRemoveIcon:true}} onChange={onChange} listType='picture-card' fileList={fileList} beforeUpload={()=>false} >
                    <Button style={{background:'none',border:'0'}} type="button">
                        <PlusOutlined />
                        Upload
                    </Button>
                </Upload>
        </Form.Item>
        <Form.Item
          wrapperCol={{
            offset: 10,
            span: 16,
          }}
        >
  
          <Button type="primary" htmlType="submit">
            Submit
          </Button>
        </Form.Item>  
      </Form></div>
  )
}

export default EditIcon